var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrIcoChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#0F9926"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3829 8.77413C15.7529 8.40862 16.3526 8.40862 16.7225 8.77413C17.0925 9.13964 17.0925 9.7321 16.7225 10.0976L11.5316 15.2261C11.3234 15.4316 11.0305 15.5299 10.7387 15.492C10.4467 15.4541 10.1884 15.2843 10.0412 15.0323L8.12704 11.7565L8.08263 11.6706C7.88613 11.238 8.04935 10.72 8.47396 10.4778C8.89883 10.2355 9.43468 10.3552 9.7155 10.7401L9.76824 10.8206L11.0644 13.0398L15.3829 8.77413Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrIcoChecked);
export default __webpack_public_path__ + "static/media/Tr_ico_checked.68b8ee915b08c889395d56b78667b311.svg";
export { ForwardRef as ReactComponent };